
/**
 * This filter applies a twist effect making display objects appear twisted in the given direction.
 *
 * @class
 * @extends PIXI.AbstractFilter
 * @memberof PIXI.filters
 */


import fragment from './ecd.frag.glsl';

function ECDFilter(opt)
{
    PIXI.AbstractFilter.call(this);

    this.uniforms = {
        viewAngle:     { type: '1f', value: 100.0 },
        speed:      { type: '1f', value: 1 },
        rate:      { type: '1f', value: 4 },
        baseamp:      { type: '1f', value: 0.25 },
        time:       { type: '1f', value: 0.5 },
        customcolor:       { type: '4f', value: [0.75,0.5,0.75,1.0] },
    }
        

    this.colorGroup = opt.colorGroup || [[0.75,0.5,0.75], [0.1,0.9,0.1] ];

    this.fragmentSrc = fragment;
}

ECDFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
ECDFilter.prototype.constructor = ECDFilter;

Object.defineProperties(ECDFilter.prototype, {
    /**
     * This point describes the the offset of the twist.
     *
     * @member {PIXI.Point}
     * @memberof PIXI.filters.ECDFilter#
     */
    time: {
        get: function ()
        {
            return this.uniforms.time.value;
        },
        set: function (value)
        {
            this.uniforms.time.value = value;
        }
    },

    viewAngle : {
        get: function() {
            return this.uniforms.viewAngle.value;
        },
        set: function(value) {
            this.uniforms.viewAngle.value = value;
        }
    },

    speed : {
        get: function() {
            return this.uniforms.speed.value;
        },
        set: function(value) {
            this.uniforms.speed.value = value;
        }
    },

    rate : {
        get: function() {
            return this.uniforms.rate.value;
        },
        set: function(value) {
            this.uniforms.rate.value = value;
        }
    },

    baseamp : {
        get: function() {
            return this.uniforms.baseamp.value;
        },
        set: function(value) {
            this.uniforms.baseamp.value = value;
        }
    },

    colorChange : {
        get: function() {
            return this.uniforms.customcolor;
        },
        set:function(value){

            // dif between two values:
            var newColorArray = [];
            for( var c = 0; c < 3; c++){

                newColorArray[c] = this.colorGroup[0][c] + ((this.colorGroup[1][c] - this.colorGroup[0][c]) * value)
            }


            this.uniforms.customcolor.value = newColorArray;


        }

    },

    color : {
        get: function() {
            return this.uniforms.customcolor.value;
        },
        set: function(value) {
            this.uniforms.customcolor.value = value;
        }  
    }

});




module.exports = ECDFilter;



/** WEBPACK FOOTER **
 ** ./src/js/controllers/filters/ecdFilter.js
 **/